
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiStabilisationIndicatorGroundIec as ObiStabilisationIndicatorGroundIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-stabilisation-indicator-ground-iec.js';
 
 
 

 
 export const ObiStabilisationIndicatorGroundIec = createComponent({
   react: React,
   tagName: 'obi-stabilisation-indicator-ground-iec',
   elementClass: ObiStabilisationIndicatorGroundIecElement,
   events: {
     
   }
  });
 
 